module.exports = __webpack_public_path__ + "platform-web/static/media/cloud-assistant.2d09b748.svg";